import LeadPartyApi from "../../service/LeadPartyService";
import ProcessApi from "../../service/ProcessService";
import AuthorizationApi from "../../service/AuthorizationService";
import moment from "moment";

export default {
  props: {
    showSelect: {
      type: Boolean,
      default: false
    }
  },
  mixins: [],
  data: function () {
    return {
      userList: [],
      searchUnitCodeDisabled: false,
      searchUnitCode: null,
      searchAssignedName: "",
      leadPartyNameList: [],
      leadIds: [],
      searchTckn: "",
      stateValues: {
        tableRefreshIntervalId: 0,
        selected: []
      },
      list: [],
      timer: null,
      pageOptions: {
        page: 1,
        itemsPerPage: 5
      },
      totalItems: 0,
      refreshing: false,
      leadPartySearch: ""
    };
  },
  watch: {
    "pageOptions.page": function () {
      this.getData();
    },
    "pageOptions.itemsPerPage": function () {
      this.getData();
    }
  },
  computed: {
    footerProps: function () {
      return {
        "items-per-page-options": [5, 10, 15, 20],
        "items-per-page-text": this.$t("itemsPerPage"),
        "page-text": "{0}-{1}  /  {2}"
      };
    },
    unitCodeItems: function () {
      let pair = [];
      for (const user of this.userList) {
        if (
          user.unitCode != null &&
          !pair.some(x => x.value === user.unitCode)
        ) {
          pair.push({
            text: this.$t(user.unitType) != null ?
              this.$t(user.unitType) :
              user.unitCode,
            value: user.unitCode
          });
        }
      }
      pair.sort(function (a, b) {
        if (b.value == "001") {
          return 1;
        } else if (a.value == "001") {
          return -1;
        } else {
          return a.text.localeCompare(b.text);
        }
      });
      return pair;
    },
    consultantItems: function () {
      let items = [];
      for (const user of this.userList) {
        if (this.searchUnitCode != null && this.searchUnitCode == user.unitCode && user.status == "ACTIVE") {
          items.push({
            text: user.fullName,
            value: user.fullName
          });
        }
      }
      return items.sort(function (a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });
    }
  },
  beforeMount: async function () {
    this.setUserList();
    LeadPartyApi.findAllNamesLeadParty(
      this,
      this.$store.getters["user"].domainId,
      null,
      [
        "Rejected",
        "Pending",
        "SelfPending",
        "SelfSuspended",
        "PreRejected",
        "Suspended",
        "NewParty"
      ],
      response => {
        if (response != null) {
          this.leadPartyNameList = response.leadPartyDTOList;
        }
      }
    );
  },
  mounted() {
    const currentUserUnitCode = this.$store.getters["user"].unitCode;
    if (currentUserUnitCode !== "001") {
      this.searchUnitCode = currentUserUnitCode;
      this.searchUnitCodeDisabled = true;
    }

    this.stateValues.tableRefreshIntervalId = window.setInterval(() => {
      this.getData();
    },10000);
    const previouslySetItemsPerPage = this.$store.getters["itemsPerPageMap"][
      this.PAGE_TYPE
    ];
    if (previouslySetItemsPerPage != null) {
      this.pageOptions.itemsPerPage = previouslySetItemsPerPage;
    }

    this.getData();
  },
  destroyed() {
    window.clearInterval(this.stateValues.tableRefreshIntervalId);
  },
  methods: {
    onMouseEnterRow(rowsToHighlight) {
      rowsToHighlight.forEach(el => {
        el.classList.add("hovered");
      });
    },
    onMouseLeaveRow(rowsToUnderstate) {
      rowsToUnderstate.forEach(el => {
        el.classList.remove("hovered");
      });
    },
    setUserList() {
      AuthorizationApi.getUsers(this, response => {
        if (response != null) {
          this.userList = response.resultList;
        }
      });
    },
    formatStatusField(status) {
      if (status) {
        if (status === "ACTIVE") {
          return this.$t("identityVerified");
        } else if (status === "REJECTED") {
          return this.$t("identityNotVerified");
        } else {
          return this.$t(status);
        }
      }
      return "";
    },
    formatPrimaryContactTypeField(primaryContactType) {
      if (primaryContactType != null) {
        return this.$t(primaryContactType.toLowerCase());
      }
      return primaryContactType;
    },
    formatDate(date) {
      if (date != null) {
        return moment(date).format("DD/MM/YYYY HH:mm:ss");
      }
    },
    formatAppointmentDateTimeField(appointmentDTO) {
      if (appointmentDTO) {
        return (
          moment(appointmentDTO.startDate).format("DD/MM/YYYY HH:mm") +
          " - " +
          moment(appointmentDTO.endDate).format("HH:mm")
        );
      }
    },
    getAssigneeUser(id) {
      if (id) {
        const user = this.userList.find(x => x.id == id);
        if (user) {
          return user;
        }
      }
      return {};
    },
    checkPreviouslyCheckedItems(ids) {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].checked =
          ids.filter(id => id === this.list[i].id).length > 0;
      }
    },
    onCheckboxChanged() {
      this.$emit(
        "onCheckedItems",
        this.list.filter(item => item.checked)
      );
    },
    onItemsPerPageChanged(itemsPerPage) {
      let itemsPerPageMap = this.$store.getters["itemsPerPageMap"];
      itemsPerPageMap[this.PAGE_TYPE] = itemsPerPage;
      this.$store.dispatch("setItemsPerPageMap", itemsPerPageMap);
    },
    onPageChanged(page) {
      this.pageOptions.page = page;
    },
    inputKeyUp() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getData();
      }, 800);
    },
    onLeadPartyFilterChanged() {
      this.leadPartySearch = "";
      this.inputKeyUp();
    },
    clearProcessId() {
      this.$store.dispatch("clearProcessId");
    },
    setProcessId(processId) {
      if (processId != null) {
        this.$store.dispatch("setProcessId", processId);
      } else {
        this.clearProcessId();
      }
    },
    onClickCustomerCard(id, tckn, processId, note) {
      this.$emit("onClickCustomerCard", id, tckn, processId, note);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/PartyProcessListTableCommon.js